function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { addWindowListener, removeWindowListener, HAS_WINDOW } from '../../utils/dom';
import { setupNotificationAutoDelay, clearNotificationTimeouts } from './helper';
import { ADD_MAIN_CONTROLS_NAMESPACE } from './constants';
var NOTIFICATION_STICKY_HEIGHT = 60;
var SCROLL_EVENT_INTERVAL = 50; // addMainControls is a HOC used to wrap a page component
// it adds several function props into the scope of the page component which is
// used in tandem with `withMainControls` to pass main content related options
// from sub components

var addMainControls = function addMainControls(PageComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(AddMainControlsWrapper, _PureComponent);

    function AddMainControlsWrapper() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, AddMainControlsWrapper);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AddMainControlsWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "state", {
        bottomBarOptions: undefined,
        notificationOptions: undefined // Add the functions in to the context tree

      });

      _defineProperty(_assertThisInitialized(_this), "_animateClose", function (next) {
        _this.setState(function (prevState) {
          return {
            notificationOptions: _objectSpread({}, prevState.notificationOptions, {
              // isClosing signals Structure to apply a css transition effect to the notification
              isClosing: true
            })
          };
        }, next);
      });

      return _this;
    }

    _createClass(AddMainControlsWrapper, [{
      key: "getChildContext",
      value: function getChildContext() {
        return {
          showMainBottomBar: this._showMainBottomBar.bind(this),
          closeMainBottomBar: this._closeMainBottomBar.bind(this),
          addMainNotification: this._addMainNotification.bind(this),
          hideMainNotification: this._hideMainNotification.bind(this)
        };
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this._unSubscribeWindowListener(); // Make sure Notification timers are cleared to prevent memory leaks


        clearNotificationTimeouts(ADD_MAIN_CONTROLS_NAMESPACE);
      }
    }, {
      key: "_showMainBottomBar",
      value: function _showMainBottomBar() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // managing the state of the main bottom bar w/in this HOC so that
        // components further down the tree don't have to
        this.setState({
          bottomBarOptions: _objectSpread({}, options, {
            isShown: true
          })
        });
      }
    }, {
      key: "_closeMainBottomBar",
      value: function _closeMainBottomBar() {
        // NOTE: We could also set `bottomBarOptions` to undefined, but since the
        // bottom bar is hidden, we don't *have* to clear out the content. that
        // would result in the markup also being cleared out. If the next time
        // the bottom bar is shown and the values end up being the same,
        // we could save some unnecessary DOM rewrites by *only* changing the
        // shown property
        // NOTE: using the callback form for `setState` since the new state
        // I want to set depends on the previous state. Because `setState`
        // is async this ensures that we're using the right version
        this.setState(function (_ref) {
          var _ref$bottomBarOptions = _ref.bottomBarOptions,
              prevBottomBarOptions = _ref$bottomBarOptions === void 0 ? {} : _ref$bottomBarOptions;
          return {
            bottomBarOptions: _objectSpread({}, prevBottomBarOptions, {
              isShown: false
            })
          };
        });
      }
    }, {
      key: "_handleScrollNotification",
      value: function _handleScrollNotification(stickyTopHeight) {
        var notificationOptions = this.state.notificationOptions;
        var children = notificationOptions.children;
        var shouldStick = notificationOptions.shouldStick;
        var shouldSetState = false;

        if (children) {
          /* We only want to call `setState` once each time the notification bar should transition
          from sticky to non-sticky, so only call `setState` when the value of 'shouldStick' should be different
          than what it currently is. */
          if (window.pageYOffset >= stickyTopHeight && !shouldStick || window.pageYOffset < stickyTopHeight && shouldStick) {
            shouldStick = !shouldStick;
            shouldSetState = true;
          }
          /* Additionally, we do not want to update our state when we don't have any children
          as they are a required prop for the notification bar component. */


          if (shouldSetState) {
            this.setState({
              notificationOptions: _objectSpread({}, notificationOptions, {
                shouldStick: shouldStick
              })
            });
          }
        }
      }
    }, {
      key: "_addMainNotification",
      value: function _addMainNotification() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Need to clear any lingering timeouts
        clearNotificationTimeouts(ADD_MAIN_CONTROLS_NAMESPACE); // managing the state of the notificationBar w/in this HOC so that
        // components further down the tree don't have to

        var isNotificationSticky = options.isNotificationSticky,
            shouldPersist = options.shouldPersist,
            _options$stickyTopHei = options.stickyTopHeight,
            stickyTopHeight = _options$stickyTopHei === void 0 ? NOTIFICATION_STICKY_HEIGHT : _options$stickyTopHei,
            notificationOptions = _objectWithoutProperties(options, ["isNotificationSticky", "shouldPersist", "stickyTopHeight"]);

        var shouldStick = false;

        if (isNotificationSticky) {
          this._unSubscribeWindowListener();

          this._debouncedHandleScrollNotification = _.debounce(this._handleScrollNotification.bind(this, stickyTopHeight), SCROLL_EVENT_INTERVAL);
          addWindowListener('scroll', this._debouncedHandleScrollNotification); //If the user is already scrolled a distance down the page,
          //notification should initially render as sticky

          if (HAS_WINDOW && window.pageYOffset >= stickyTopHeight) {
            shouldStick = true;
          }
        }

        this.setState({
          notificationOptions: _objectSpread({
            shouldStick: shouldStick,
            isClosing: false,
            hasCloseButton: true
          }, notificationOptions, {
            // Need to always pass in `onClose` so that if the notificationBar
            // button is pressed this HOC can set its internal state.
            // If an `onClose` was passed in, it'll get called.
            onClose: this._hideMainNotification.bind(this, notificationOptions.onClose)
          })
        }); // Self remove non-callAction notifications. Notifications
        // which have CTAs should not be auto removed

        if (!notificationOptions.callAction && !shouldPersist) {
          // Fire the notification removal sequence
          setupNotificationAutoDelay(this._animateClose, this._hideMainNotification.bind(this, notificationOptions.onClose), ADD_MAIN_CONTROLS_NAMESPACE);
        }
      }
    }, {
      key: "_hideMainNotification",
      value: function _hideMainNotification(onClose) {
        // Need to clear any lingering timeouts
        clearNotificationTimeouts(ADD_MAIN_CONTROLS_NAMESPACE);

        this._unSubscribeWindowListener(); // NOTE: We set the notificationOptions to null so that nothing is displayed


        this.setState(function () {
          return {
            notificationOptions: null
          };
        });

        if (onClose) {
          onClose();
        }
      }
    }, {
      key: "_unSubscribeWindowListener",
      value: function _unSubscribeWindowListener() {
        if (this._debouncedHandleScrollNotification) {
          removeWindowListener('scroll', this._debouncedHandleScrollNotification);
          this._debouncedHandleScrollNotification = null;
        }
      } // Pass bottomBarOptions & notificationOptions back into the page component's scope as props

    }, {
      key: "render",
      value: function render() {
        var _this$state = this.state,
            bottomBarOptions = _this$state.bottomBarOptions,
            notificationOptions = _this$state.notificationOptions;
        return React.createElement(PageComponent, _extends({
          mainBottomBarOptions: bottomBarOptions,
          notificationOptions: notificationOptions
        }, this.props));
      }
    }]);

    return AddMainControlsWrapper;
  }(PureComponent), _defineProperty(_class, "childContextTypes", {
    showMainBottomBar: PropTypes.func,
    closeMainBottomBar: PropTypes.func,
    addMainNotification: PropTypes.func,
    hideMainNotification: PropTypes.func
  }), _temp;
};

export default addMainControls;